<template>
  <div class="footer-desk show-for-large">
    <div class="footer-main-logo">
      <!-- Logo completo di fallback -->
      <img
        v-if="false"
        src="@/assets/img/logos/logo-footer-completo.svg"
        :alt="runtimeConfig.public.siteName"
      />
      <img
        class="footer-main-logo-monogram"
        src="@/assets/img/logos/logo_inside_ring.svg"
        :alt="runtimeConfig.public.siteName"
      />
      <img
        class="footer-main-logo-ring"
        src="@/assets/img/logos/footer-ring-new.svg"
        :alt="runtimeConfig.public.siteName"
      />
    </div>

    <!-- Riga Menu principale, link di navigazione, corporate data ecc -->
    <div class="footer-main-row flex row-190-40">
      <div class="footer-col main-menu flex text-corpo-l">
        <div class="main-menu-left">
          <ul>
            <li>
              <NuxtLink
                data-no-cursor
                class="main-menu-left-link text-corpo-xxl is-xlight link-underline-reverse-1"
                :to="localePath({ name: 'sidri' })"
              >
                <span>{{ $t(`footer.main.ciders-and-spirits`) }}</span>
              </NuxtLink>
            </li>
            <li>
              <NuxtLink
                data-no-cursor
                class="main-menu-left-link text-corpo-xxl is-xlight link-underline-reverse-1"
                :to="localePath({ name: 'alta-quota' })"
              >
                <span>{{ $t(`footer.main.high-altitude`) }}</span>
              </NuxtLink>
            </li>
            <li>
              <NuxtLink
                data-no-cursor
                class="main-menu-left-link text-corpo-xxl is-xlight link-underline-reverse-1"
                :to="localePath({ name: 'savoir-faire' })"
              >
                <span>{{ $t(`footer.main.savoir-faire`) }}</span>
              </NuxtLink>
            </li>
            <li>
              <NuxtLink
                data-no-cursor
                class="main-menu-left-link text-corpo-xxl is-xlight link-underline-reverse-1"
                :to="localePath({ name: 'contatti' })"
              >
                <span>{{ $t(`footer.main.contacts`) }}</span>
              </NuxtLink>
            </li>
          </ul>
        </div>
      </div>

      <div class="footer-col info">
        <div
          data-no-cursor
          v-if="corporate?.generalInfo"
          class="text-corpo-l is-xlight"
          v-html="corporate.generalInfo"
        />
      </div>
    </div>

    <!-- Riga bottom, policies and credits -->
    <div class="footer-main-row row-190-40 flex text-sans-s corporate">
      <div class="footer-col">
        <div class="footer-main-corporate is-xlight flex">
          <p v-html="$t('footer.main.copyright', { year: actualYear })" />
          <nuxt-link
            data-no-cursor
            class="link-underline-reverse-1"
            :to="
              localePath({
                name: 'privacy-policy',
              })
            "
            ><span>{{ $t('footer.main.privacy') }}</span>
          </nuxt-link>
          <!-- <nuxt-link
            data-no-cursor
            class="link-underline-reverse-1"
            :to="
              localePath({
                name: 'cookie-policy',
              })
            "
            ><span>Cookie Policy</span>
          </nuxt-link> -->
        </div>
      </div>

      <div class="footer-col footer-credits">
        <p>
          Designed by:
          <a
            v-if="!isErrorPage"
            data-no-cursor
            class="link-underline-reverse-1 is-xlight"
            target="_blank"
            rel="noopener"
            href="https://www.quamm.it/"
            >Quamm</a
          >
          <span v-else>Quamm</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterLarge',
}
</script>

<script setup>
const runtimeConfig = useRuntimeConfig()
const actualYear = computed(() => new Date().getFullYear())

const switchLocalePath = useSwitchLocalePath()
const { locale, locales, setLocale } = useI18n()

const props = defineProps({
  corporate: Object || null,
})

const isErrorPage = computed(() => !!useError().value)
</script>
